/** @file The editor-wide playback clock: steps mix previews and playback while the editor frame is open. */
import { compiledStore } from '../stores/compiledStore';
import { currentDoc } from '../stores/currentDoc';
import { docStore } from '../stores/docStore';
import { playheadStore } from '../stores/playheadStore';
import { createPlaybackClock, type ClockDeps } from './createPlaybackClock';
import { followMixPair } from './followMixPair';
import { mixPreviewStore } from './mixPreviewStore';
import { playbackTick } from './playbackTick';
import { playhead } from './playhead';

/**
 * Started once by EditorFrame (never by a closable panel). A project switch clears the mix preview (its pair is the
 * old project's ids); a document change keeps the pair on its animations (followMixPair). The returned stop ends
 * the clock, the preview and playback.
 */
export function startPlayback(clock: ClockDeps): () => void {
  const stopClock = createPlaybackClock(clock, (dt) => { playbackTick(dt, compiledStore.getState().data); });
  let { projectId } = docStore.getState();
  let doc = currentDoc(docStore.getState());
  const stopWatch = docStore.subscribe((state) => {
    const next = currentDoc(state);
    if (state.projectId !== projectId) {
      projectId = state.projectId;
      mixPreviewStore.setState(mixPreviewStore.getInitialState(), true);
    } else if (next !== null && next !== doc) {
      followMixPair(doc, next);
    }
    doc = next;
  });
  return () => {
    stopClock();
    stopWatch();
    if (mixPreviewStore.getState().run !== null) mixPreviewStore.setState({ run: null });
    if (playheadStore.getState().playing) playhead.pause();
  };
}
